export const formatMoney = (
  amount: number | null | undefined,
  currency = "USD",
): string | null => {
  if (amount == null) {
    return null;
  }
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
  }).format(amount);
};
